import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

const linkModule = () => {

    const links = document.querySelectorAll('.js-link-wrapper');

    links.forEach(link => {

        const linkWrapper = link.querySelector('.js-link');

        ScrollTrigger.matchMedia({
            "(pointer: fine)": function() {

                const splitText = new SplitText(linkWrapper, {
                    type: "chars, words, lines",
                    reduceWhiteSpace: false,

                });

                let chars = [];

                splitText.chars.forEach(char => {

                    const wrapper = document.createElement('div');
                    const inner = document.createElement('div');

                    inner.classList.add('inline-flex', 'flex-col', 'relative');
                    wrapper.classList.add('inline-flex', 'relative', 'overflow-hidden');

                    wrapper.appendChild(inner);

                    char.parentNode.insertBefore(wrapper, char);

                    inner.appendChild(char);
                    inner.appendChild(char.cloneNode(true));

                    // get last element inside inner
                    const lastElement = inner.lastElementChild;
                    lastElement.classList.add('absolute!', 'bottom-0', 'left-0', 'translate-y-full');

                    chars.push(inner);

                });

                link.addEventListener('mouseenter', () => {

                    const tl = gsap.timeline();

                    tl.to(chars, {
                        yPercent: -100,
                        ease: "power3.out",
                        duration: 0.5,
                        stagger: {
                            amount: 0.1,
                            from: 'random',
                        }
                    })
                    .to(chars, {
                        yPercent: 0,
                        duration: 0,
                    });

                });

            }
        });


    });

}

export { linkModule };